import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/pages/Login.vue'
import Principal from '@/components/pages/Principal.vue'
import Category from '@/components/pages/Category.vue'
import Video from '@/components/pages/Video.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false
    }
  }, {
    path: '',
    name: 'home',
    redirect: {
      name: 'category'
    },
    meta: {
      auth: true
    }
  }, {
    path: '/category',
    name: 'category',
    component: Category,
    meta: {
      auth: true
    }
  }, {
    path: '/category/:id',
    component: Video,
    meta: {
      auth: true
    }
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js